module.exports = __webpack_public_path__ + "media/images/mha-logo-4754951268715967923484fd715a72a8.svg";